import { SettingsPage } from "./SettingsPage"

export function LocalesPage() {
  return <SettingsPage pageName="Locales" />
}
